// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qZwU","type":"styles_type__133Gk","choices":"styles_choices__Rd2bL"};